// Hack to get require(..) working in TypeScript. EDCO was originally developed with
// Javascript and we then added TypeScript support.
// (Hack from: https://www.typescriptlang.org/docs/handbook/migrating-from-javascript.html)
// declare function require(path: string): any;

'use strict';

/* ========================================================
 * 		jQuery
 *
 * If you need jQuery in a JS file add this to the top of that file:
 * 		var $ = require('jquery');
 * If some JS code MUST have jQuery globally accessible then
 * add the following line inside this file (index.js).
 * 		var $ = window.jQuery = require('jquery');
 ========================================================= */

/* ========================================================
 * 		Requires
 ========================================================= */

var detectBrowser = require('./lib/detectBrowser.js');
detectBrowser.addStyleClasses();

// Polyfills
require('./polyfills/requestAnimationFrame.js');

// Lib
var $ = window.jQuery = require('jquery');
document.addEventListener('jsfAjaxEvent', function(event) {
	var data = event.detail;
	var fireType = data.fireType;
	$(event.target).trigger('jsfAjax' + fireType.charAt(0).toUpperCase() + fireType.substring(1), data);
});

/* ========================================================
 * 		Animations
 ========================================================= */
// Add custom easing animations
var AnimationEasing = require('./lib/AnimationEasing.js');
AnimationEasing.addEasing('interaction', AnimationEasing.bezier(.3,1,.8,1));
AnimationEasing.addEasing('noInteraction', AnimationEasing.bezier(.4,.69,.5,1));

// Create global 'scroll' Animation Manager
var Animation = require('./lib/Animation.js');

var debug = false;

// Always on animations
var animAlways = new Animation.Manager({debug: debug});
Animation.Manager.setInstance('scroll', animAlways);

// Desktops animations
var animDesktop = new Animation.Manager({debug: debug});
Animation.Manager.setInstance('scroll--desktop', animDesktop);


// Mobile animations
var animMobile = new Animation.Manager({debug: debug});
Animation.Manager.setInstance('scroll--mobile', animMobile);

/* ========================================================
 * 		Component Setup
 ========================================================= */
require('./lib/Forms.js').init();
require('./site/MainMenu.js').init();
require('./site/Masthead.js').init();
var AccessibleDropdown = require('./site/AccessibleDropdown.js');

// Pages
require('./site/ProductCategory.js').init();
require('./site/ProductLine.js').init();
require('./site/SocialShare.js').init();
require('./site/Inspiration.js').init();
// require('./site/InspirationTool.js').init();
require('./site/HeaderSearchForm.js').init();
require('./site/Entry.js').init();
require('./site/Warranty.js').init();
require('./site/WarrantyForm.js').init();
require('./site/FileUpload.js').init();
require('./site/Gallery.js').init();

AccessibleDropdown.init('.inspirationFilter', 'isActive', 'mobile');

/* ========================================================
 * 		Animations - Start them now that components have had a chance to register.
 ========================================================= */
animAlways.start();
Animation.runConditionalOnViewport(animDesktop, function(state) {return state !== 'mobile';});
Animation.runConditionalOnViewport(animMobile, function(state) {return state === 'mobile';});

/* ========================================================
 * 		StateManager
 ========================================================= */
// Now that everything has had a chance to register with the StateManager
// we can do the init work that loads the current page state.
var StateManager = require('./lib/StateManager.js');
StateManager.instance.init();
